export const keysList = {
  certifications: 'certifications',
  inspection_requirements: 'inspection_requirements',
  user: 'user',
  company: 'company',
  categorized_web_materials: 'categorized_web_materials',
  company_categorized_web_materials: 'company_categorized_web_materials',
  processes: 'processes',
  categorized_processes: 'categorized_processes',
  categorized_finishes: 'categorized_finishes',
  machines: 'machines',
  materials: 'materials',
  finishes: 'finishes',
  build_time: 'build_time',
};

/* eslint-disable space-before-blocks,camelcase */

/* eslint-disable quote-props,no-use-before-define,guard-for-in,prefer-const,comma-dangle,
no-restricted-syntax,no-undef,semi */
class Cache {
  static checkCacheExpired() {
    let build_time = this.get('build_time');
    if (build_time !== BUILD_TIME) {
      this.clear();
      this.set('build_time', BUILD_TIME);
    }
  }

  static set(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  static get(key) {
    return JSON.parse(localStorage.getItem(key));
  }

  static hasKey(key) {
    this.checkCacheExpired();
    return !!localStorage.getItem(key);
  }

  static remove(key) {
    localStorage.removeItem(key);
  }

  static clear() {
    for (let prop in keysList) {
      this.remove(keysList[prop]);
    }
  }
}

export default Cache;
